module.exports = __webpack_public_path__ + "static/media/thyme.08ae1b82.webp";